<app-hero-section>
  <picture *ngIf="darkMode; else lightMode">
    <source
      media="(min-width: 1024px)"
      srcset="
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_darkmode@1x.avif 1920w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_darkmode@1x.webp 1920w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_darkmode@1x.avif 1440w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_darkmode@1x.webp 1440w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.avif      1024w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.webp      1024w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_darkmode@1x.avif        640w,
        https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_darkmode@1x.webp        640w
      "
      sizes="(max-width: 640px) 640px,
                   (max-width: 1024px) 1024px,
                   (max-width: 1440px) 1440px,
                   1920px"
      type="image/avif"
    />
    <img
      class="h-full w-full object-cover"
      src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.webp"
      alt="ayr_citizens_greenwarriors"
      fetchpriority="high"
    />
  </picture>
  <ng-template #lightMode>
    <picture>
      <source
        media="(min-width: 1024px)"
        srcset="
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_lightmode@1x.avif 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_lightmode@1x.webp 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_lightmode@1x.avif 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_lightmode@1x.webp 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.avif      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.webp      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_lightmode@1x.avif        640w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_lightmode@1x.webp        640w
        "
        sizes="(max-width: 640px) 640px,
                  (max-width: 1024px) 1024px,
                  (max-width: 1440px) 1440px,
                  1920px"
        type="image/avif"
      />
      <img
        class="h-full w-full object-cover"
        src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.webp"
        alt="ayr_citizens_greenwarriors"
        fetchpriority="high"
      />
    </picture>
  </ng-template>
</app-hero-section>
<div class="bg-white dark:bg-black text-ayr-black dark:text-white max-w-screen-xl px-6 lg:px-32 py-8 lg:py-16 mx-auto w-full flex flex-col items-start gap-4">
    <h1 class="inline-block ayr-underline mb-4 lg:mb-7">
      {{ "terms_and_conditions_title" | translate }}
    </h1>
    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_presentations" | translate }}
    </p>
    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_1" | translate }}
      <span class="block">
        {{ "terms_and_conditions_2" | translate }}
      </span>
    </p>
    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_3" | translate }}
    </p>
    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_ayr_definition" | translate }}
    </p>

    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_user_definition" | translate }}
    </p>

    <ul class="list">
      <li>
        <span class="pt-4 !text-ayr-black dark:!text-white">
          {{ "terms_and_conditions_user_definition_1" | translate }}
        </span>
      </li>
      <li>
        <span class="pt-4 !text-ayr-black dark:!text-white">
          {{ "terms_and_conditions_user_definition_2" | translate }}
        </span>
      </li>
      <li>
        <span class="pt-4 !text-ayr-black dark:!text-white">
          {{ "terms_and_conditions_user_definition_3" | translate }}
        </span>
      </li>
    </ul>
    <p class="pt-4 !text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_4" | translate }}
      <span class="d-block">
        {{ "terms_and_conditions_5" | translate }}
      </span>
      {{ "terms_and_conditions_6" | translate }}
      <span class="d-block">
        {{ "terms_and_conditions_7" | translate }}
      </span>
    </p>
    <p class="!text-ayr-black dark:!text-white">
      {{ "terms_and_conditions_8" | translate }}
      <span class="d-block">
        {{ "terms_and_conditions_9" | translate }}
      </span>
    </p>
    <div class="bg-[#F4F4F4] dark:bg-[#0F0F0F] w-full rounded mt-4 lg:mt-7">
      <mat-accordion multi>
        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(0)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2 teste"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_regist_access" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_regist_access_1" | translate }}
              <span class="block">
                {{ "terms_and_conditions_regist_access_2" | translate }}
              </span>
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_regist_access_3" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_regist_access_4" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_regist_access_5" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(1)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_operation" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_operation_1" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_operation_2" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_operation_3" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_operation_4" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_operation_5" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(2)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_intel_prop" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_intel_prop_1" | translate }}
            </p>

            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_intel_prop_2" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_intel_prop_3" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(3)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_links" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_links_1" | translate }}
              <span class="block">
                {{ "terms_and_conditions_links_2" | translate }}
              </span>
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(4)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[4].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[4].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_personal_data" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_personal_data_1" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(5)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[5].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[5].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_responsibility" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_1" | translate }}
              <span class="block">
                {{ "terms_and_conditions_responsibility_2" | translate }}
              </span>
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_3" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_4" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_5" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_6" | translate }}
                </span>
              </li>
            </ul>

            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_7" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_8" | translate }}
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white"
                  >{{ "terms_and_conditions_responsibility_1_1" | translate }}
                </span>

                <ul class="sublist" [ngClass]="{ 'sublist-dark': darkMode }">
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_2" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_3" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_4" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_5" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white"
                      >{{
                        "terms_and_conditions_responsibility_1_1_6" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white"
                      >{{
                        "terms_and_conditions_responsibility_1_1_7" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_8" | translate
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="pt-4 !text-ayr-black dark:!text-white">
                      {{
                        "terms_and_conditions_responsibility_1_1_9" | translate
                      }}
                    </span>
                  </li>
                </ul>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_1_2_1" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_1_2_2" | translate }}
                </span>
              </li>
            </ul>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_1_3" | translate }}
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white"
                  >{{ "terms_and_conditions_responsibility_1_3_1" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_1_3_2" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_1_3_3" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_responsibility_1_3_4" | translate }}
                </span>
              </li>
            </ul>

            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_1_4" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_responsibility_1_5" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(6)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[6].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[6].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_force_events" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_force_events_1" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_force_events_2" | translate }}
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_1" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_2" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_3" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_4" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_5" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_6" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_force_events_2_7" | translate }}
                </span>
              </li>
            </ul>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_force_events_3" | translate }}
              <span class="block">
                {{ "terms_and_conditions_force_events_4" | translate }}
              </span>
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(7)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[7].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[7].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_cancellation" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_cancellation_1" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_cancellation_2" | translate }}
              <span class="block">
                {{ "terms_and_conditions_cancellation_3" | translate }}
              </span>
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_cancellation_4" | translate }}
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_cancellation_4_1" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_cancellation_4_2" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_cancellation_4_3" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_cancellation_4_4" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_cancellation_4_5" | translate }}
                </span>
              </li>
            </ul>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_cancellation_4_6" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(8)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[8].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[8].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_suggestions" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_suggestions_1" | translate }}
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(9)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[9].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[9].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_agreement" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_agreement_1" | translate }}
              <span class="block">
                {{ "terms_and_conditions_agreement_2" | translate }}
              </span>
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_agreement_3" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_agreement_4" | translate }}
              <span class="block">
                {{ "terms_and_conditions_agreement_5" | translate }}
              </span>
            </p>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(10)">
          <mat-expansion-panel-header
            class="!h-auto dark:hover:!bg-[#202020] dark:focus-visible:!bg-[#202020] hover:!bg-[#f0efef] focus-visible:!bg-[#f0efef] text-ayr-black dark:text-white"
          >
            <mat-panel-title>
              <div
                class="text-ayr-black dark:text-white flex items-center gap-2"
              >
                <img
                  class="duration-200"
                  *ngIf="darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[10].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <img
                  class="duration-200"
                  *ngIf="!darkMode"
                  [ngClass]="{ 'rotate-90': principalAccordion[10].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
                <span class="dark:text-white">{{
                  "terms_and_conditions_jurisdiction" | translate
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-expansion-content text-ayr-black dark:text-white">
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_jurisdiction_1" | translate }}
            </p>
            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_jurisdiction_2" | translate }}
            </p>

            <p class="!text-ayr-black dark:!text-white">
              {{ "terms_and_conditions_jurisdiction_3" | translate }}
            </p>
            <ul class="list">
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_jurisdiction_4" | translate }}
                </span>
              </li>
              <li>
                <span class="pt-4 !text-ayr-black dark:!text-white">
                  {{ "terms_and_conditions_jurisdiction_5" | translate }}
                  <a
                    href="{{ 'terms_link' | translate }}"
                    role="link"
                    id="link-schedule"
                    aria-label="Contact ceiia through email to schedule a meeting"
                    >{{ "terms_and_conditions_jurisdiction_6" | translate }}</a
                  >.</span
                >
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
</div>
